var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.5625C8.99695 3.5625 6.5625 5.99695 6.5625 9C6.5625 12.003 8.99695 14.4375 12 14.4375C15.003 14.4375 17.4375 12.003 17.4375 9C17.4375 5.99695 15.003 3.5625 12 3.5625ZM5.4375 9C5.4375 5.37563 8.37563 2.4375 12 2.4375C15.6244 2.4375 18.5625 5.37563 18.5625 9C18.5625 12.6244 15.6244 15.5625 12 15.5625C8.37563 15.5625 5.4375 12.6244 5.4375 9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 15.5625C10.2555 15.5625 8.54164 16.0216 7.03069 16.8936C5.51974 17.7656 4.26489 19.0199 3.39218 20.5305C3.23677 20.7995 2.89273 20.8916 2.62373 20.7362C2.35474 20.5808 2.26266 20.2367 2.41807 19.9677C3.38953 18.2862 4.7864 16.89 6.46834 15.9192C8.15027 14.9485 10.058 14.4375 12 14.4375C13.942 14.4375 15.8497 14.9486 17.5317 15.9193C19.2136 16.8901 20.6104 18.2864 21.5819 19.9679C21.7373 20.2369 21.6452 20.581 21.3762 20.7364C21.1072 20.8918 20.7631 20.7997 20.6077 20.5307C19.735 19.0201 18.4802 17.7658 16.9693 16.8937C15.4584 16.0216 13.7445 15.5625 12 15.5625Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.43a1eaec88680a3d6cc47755294b73d0.svg";
export { ForwardRef as ReactComponent };